import { render } from "./Loading.vue?vue&type=template&id=3d1337d2"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=3d1337d2&lang=css"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__